import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'

/**
 * Sayfa bazlı yetkili kontrolü (MTAdminAuth deseni). Backend, oturumdaki admin'in
 * TableSiteStructures'taki sayfa listesinde olup olmadığını döner. Asıl koruma backend'de:
 * sayfanın tüm uçları yetkisiz kullanıcıya hata döner; bu uç yalnız ekranı göstermek için.
 */
export type AdminPageAuthRoute = 'PosSettingsAuth' | 'DealerCreditCardAuth' | 'ChatbotManagementReportAuth'

export class AdminPageAuthApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo, route: AdminPageAuthRoute) {
    super({
      url: `admin/auth/${route}`,
      requesterInfo,
    })
  }

  public async getAuth(): Promise<boolean> {
    return await this.getAsync<boolean>()
  }
}
